import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DragSource } from 'react-dnd';
import { hasCheckedCardInAppGroup, getCardList } from '../../utilService';

const noteSource = {
    beginDrag(props, monitor, component) {
        const cardList = getCardList(props.appGroupArr, props.id);
        return { type: 'cardList', cardList: cardList };
    },
    endDrag(props, monitor, component) {
        if (monitor.didDrop()) {
            //endDrag，重置Sidle区域中的卡片
            props.resetSelectedCards();
        }
    }
};

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
    };
}

class SideCard extends Component {

    // 点击每一项
    clickSideCard = () => {
        const { index, parentIndex, checked, onChangeChecked } = this.props;
        onChangeChecked(!checked, parentIndex, index);
    }
    // 卡片字体
    cardTitleIsChecked = (checked) => {
        let result = null;
        if (checked) {
            result = {
                border: window.nccColor == 'black' ? '1px dashed #0153CC' : '1px dashed #2563eb'
            }
        } else {
            result = window.nccColor == 'black' ? { border: '1px dashed transparent' } : null
        }
        return result;
    }
    // 卡片图标
    cardIconIsChecked = () => {
        const { json, checked } = this.props;
        let result = null;
        if (checked) {
            result = <i
                title={json['DesktopSetting-000039']}/* 国际化处理： 卡片已选中*/
                className="iconfont icon-peizhi_tianjia iconlocation"
                style={{ color: "#2563eb" }}
            />
        } else {
            result = <i
                title={json['DesktopSetting-000040']}/* 国际化处理： 卡片未选中*/
                className="iconfont icon-peizhi_tianjia iconlocation unSelect"
            />
        }
        return result;
    }
    //搜索结果高亮关键字
    getCardName = (name) => {
        const { searchValue } = this.props;
        if (name.includes(searchValue)) {
            const index = name.indexOf(searchValue);
            const beforeStr = name.substr(0, index);
            const afterStr = name.substr(index + searchValue.length);
            return (
                <span>
                    {beforeStr}
                    <span style={{ color: "#f50" }}>{searchValue}</span>
                    {afterStr}
                </span>
            );
        } else {
            return name;
        }
    };
    render() {
        const { name, checked, connectDragSource, cardList, card } = this.props;
        const nameShow = this.getCardName(name);
        const isExistence = hasCheckedCardInAppGroup(cardList, card.appid);
        return connectDragSource(
            <div
                className='list-item-content'
                onClick={this.clickSideCard}
                style={this.cardTitleIsChecked(checked)}
            >
                <div className={checked ? `title titleChecked` : `title`}>
                    <span className='title-name' style={isExistence ? { color: '#2563eb' } : {}}>{nameShow}</span>
                </div>
                {this.cardIconIsChecked()}
            </div>
        )
    }
}
const dragDropItem = DragSource('item', noteSource, collectSource)(SideCard);
export default connect(
    (state) => ({
        json: state.gridLayoutData.json
    }),
)(dragDropItem);
